var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestEnvironmentHover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 8.5,
    r: 2.5,
    stroke: "#1847CA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.57735C7.1188 1.22008 7.8812 1.22008 8.5 1.57735L12.9952 4.17265C13.614 4.52992 13.9952 5.19017 13.9952 5.9047V11.0953C13.9952 11.8098 13.614 12.4701 12.9952 12.8274L8.5 15.4226C7.8812 15.7799 7.1188 15.7799 6.5 15.4226L2.00481 12.8274C1.38601 12.4701 1.00481 11.8098 1.00481 11.0953V5.9047C1.00481 5.19017 1.38601 4.52992 2.00481 4.17265L6.5 1.57735Z",
    stroke: "#1847CA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestEnvironmentHover);
export default __webpack_public_path__ + "static/media/test-environment-hover.4ca9fd62468663e23c7c2d5fd0a8b3d2.svg";
export { ForwardRef as ReactComponent };